/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendationListResponse {
    getFixupPrototypeFunction() { return PolicyRecommendationListResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendationListResponse>): PolicyRecommendationListResponse {
        let obj = Object.assign(new PolicyRecommendationListResponse(), model);
        PolicyRecommendationListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendationListResponse>): PolicyRecommendationListResponse {
        if (!model) return null;
        return PolicyRecommendationListResponse.newInstance(<PolicyRecommendationListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendationListResponse) {
        if (!obj) return;

        models.PolicyRecommendationListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendationListResponse): boolean {
        Object.setPrototypeOf(obj, PolicyRecommendationListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendations) {
            models.PolicyRecommendation.fixupPrototype(this.recommendations);
        }
    }

    /**
     * Policy recommendation Info list
     */
    recommendations: models.PolicyRecommendation;

}
